import styled from 'styled-components'

export const EditItemPanel = styled.div<{
  isEditItemPanelActive: boolean
}>`
  display: ${(props) => (props.isEditItemPanelActive ? 'block' : 'none')};

  .edit-item-header {
    background-color: #c1dfc4;
    font-weight: 600;
    padding: 20px 15px;
    position: relative;
    pointer-events: all;

    @media (min-width: 1200px) {
      background-color: transparent;
      border-bottom: 1px solid #1d1d1b;
      font-size: 20px;
    }

    .button-done {
      position: absolute;
      top: 50%;
      right: 30px;
      transform: translateY(calc(-50% - 1px));
      border: none;
      background-color: transparent;
      padding: 0;
      font-weight: 500;
      font-size: 0.9em;

      @media (min-width: 1200px) {
        right: 60px;
        border: 1px solid #707070;
        padding: 8px 25px;
        color: #1b5f4b;

        &:hover {
          background-color: #f2f2e6;
          color: #324c31;
        }
      }
    }
  }

  .lfc-configurator {
    // TODO: get rid of magic constants
    height: calc(100vh - 235px); // sum of space between header and configruator in panel
    overflow-y: auto;
    padding: 0 15px;
    background-color: #ffffff;
    margin-top: 30px;

    @media (min-width: 768px) {
      margin-top: 40px;
    }

    @media (min-width: 1200px) {
      max-height: calc(100vh - 240px); // needs improvement
      padding-bottom: 75px;
    }
  }
`
